import { SearchField } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import type { AllHTMLAttributes } from 'react';
type SearchProps = {
  searchString: string;
  onSearch: (searchString?: string) => void;
  onChange?: AllHTMLAttributes<HTMLInputElement>['onChange'];
  showLabel?: boolean;
  showPlaceholder?: boolean;
};
function Search({
  searchString,
  showLabel = true,
  onSearch,
  onChange,
  showPlaceholder = true
}: SearchProps) {
  const {
    t
  } = useTranslation(['integrationsv2', 'common']);
  return <SearchField id="integrations-search" label={showLabel ? t('searchLabel') : undefined} placeholder={showPlaceholder ? t('searchPlaceholder') : ''} value={searchString} searchLabel={t('search', {
    ns: 'common'
  })} clearLabel={t('clearSearch', {
    ns: 'common'
  })} onSearch={onSearch} onChange={onChange} data-sentry-element="SearchField" data-sentry-component="Search" data-sentry-source-file="search.tsx" />;
}
export { Search };